import { render, staticRenderFns } from "./goodsBaseSales.vue?vue&type=template&id=479b86e0&"
import script from "./goodsBaseSales.vue?vue&type=script&lang=js&"
export * from "./goodsBaseSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports